import facturaPdf from "../../../../Pdf/facturaPdf";
import remisionPdf from "../../../../Pdf/remisionPdf";

const MARCA_AGUA = { text: "ACLARACIÓN", color: "gray", opacity: 0.08, bold: true, angle: -45, fontSize: 90 };

const folioDocumento = (documento) => {
    const dataSat = documento.respuestaFactura?.dataSat || {};
    return [dataSat.Serie, dataSat.Folio].filter((x) => x !== undefined && x !== null && x !== "").join("-");
};

const aclaracionCobroPdf = (documento) => ({
    ...(documento.factura ? facturaPdf(documento) : remisionPdf(documento)),
    watermark: MARCA_AGUA,
});

export { folioDocumento };
export default aclaracionCobroPdf;
